import HiddenMessage from './hidden-message'
export default HiddenMessage
